export default __webpack_public_path__ + "static/media/imageBannerBeOnline.1f1859e1.png";